import { IconWrapper } from '../runtime';
export default IconWrapper('loading', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", [h("path", {
    "attrs": {
      "vector-effect": "non-scaling-stroke",
      "d": "M8 1.99976C4.68629 1.99976 2 4.68606 2 7.99976C2 11.3135 4.68629 13.9998 8 13.9998",
      "stroke": 'url(#' + props.id + 'b6f0f5ec' + ')',
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "vector-effect": "non-scaling-stroke",
      "d": "M8 1.99975C11.3137 1.99975 14 4.68605 14 7.99971C14 10.2206 12.7934 12.1596 11 13.197",
      "stroke": 'url(#' + props.id + 'a4b861e4' + ')',
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "vector-effect": "non-scaling-stroke",
      "d": "M8 13.9998C9.09286 13.9998 10.1175 13.7076 11 13.1971",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + 'b6f0f5ec',
      "x1": "7.5",
      "y1": "13.9998",
      "x2": "8",
      "y2": "2.99976",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": props.colors[0],
      "stop-opacity": "0"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": props.colors[0],
      "stop-opacity": "0.5"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + 'a4b861e4',
      "x1": "8",
      "y1": "11.9998",
      "x2": "8",
      "y2": "2.99975",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": props.colors[0]
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": props.colors[0],
      "stop-opacity": "0.5"
    }
  })])])]);
});